import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';

const DeleteIngredientDialog = ({
  open,
  onClose,
  onConfirm,
  ingredient,
  isDeleting,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isDeleting ? undefined : onClose}
      fullWidth
      maxWidth='xs'
    >
      <DialogTitle sx={{ pr: 7 }}>
        Delete ingredient
        <IconButton
          onClick={onClose}
          disabled={isDeleting}
          sx={{ position: 'absolute', right: 16, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant='s16_w500'>
          Are you sure you want to delete <strong>{ingredient?.nameEn ?? 'this ingredient'}</strong>?
        </Typography>
        <Stack mt={2} spacing={0.5}>
          <Typography variant='s16_w500' color='#6B7280'>
            English: {ingredient?.nameEn ?? '-'}
          </Typography>
          <Typography variant='s16_w500' color='#6B7280'>
            Norwegian: {ingredient?.nameNo ?? '-'}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button variant='outlined' onClick={onClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          color='error'
          variant='contained'
          onClick={onConfirm}
          disabled={isDeleting}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteIngredientDialog;
